import matchMediaConst from "constant/matchmedia";
import { useCustomScreenSize } from "hoc/useScreenSize";
import dynamic from "next/dynamic";
import { cloneElement, useEffect, useState } from "react";
import HideIf from "util/HideIf";
import ViewAllButton from "../ViewAllButton";
import styles from "./category-section.module.scss";
const SearchBar = dynamic(() => import(/* webpackChunkName: "search-bar" */"component/searchBar/SearchBar"));

function CategorySection(props: any) {
  const [showAll, setShowAll] = useState(false);
  const {
    categoryUrls, title, maxRows = 3, listStyle = {},
    blueBorderOnHover = false,
    searchPlaceholder = "", handleSearchValueHandler: defaultSandleSearchValueHandler,
  } = props;
  const [searchResult, setSearchResult] = useState(categoryUrls || []);

  useEffect(() => {
    if (categoryUrls?.length > 0) {
      setSearchResult(categoryUrls);
    }
  }, [categoryUrls]);

  const isMobile = useCustomScreenSize({
    maxWidth: matchMediaConst.XS_MAX,
  });
  const columnItemCount = isMobile ? 2 : 5;
  const itemsToShow = showAll ? searchResult.length : maxRows * columnItemCount;

  // categoryUrls check is required
  // go to https://partsavatar.ca/engine-components
  // select 2010 Honda Civic, page was crashing if you remove this check
  if (!categoryUrls?.length) {
    return null;
  }

  function handleSearchValueHandler(searchPhrase: string) {
    const updatedData = defaultSandleSearchValueHandler(searchPhrase);
    setSearchResult(updatedData);
  }

  return (
    <div className="m-b-20">

      <div className="d-flex justify-content-center flex-wrap">
        <h2 className={styles.h2}>{title}</h2>
        {defaultSandleSearchValueHandler && (
          <SearchBar
            placeholder={searchPlaceholder}
            searchValueHandler={handleSearchValueHandler}
            hideResults
            hideHeading
            className={styles.searchbar}
            searchClassName={styles.search_order}
          />
        )}
      </div>

      <div>

        <ul className={`row m-lr-0 ${styles.category_ul}`}>
          {searchResult
            .map((categoryUrl: any, index: any) => (
              <HideIf key={index} show={!(index > itemsToShow - 1)}>
                <li className={`col-sm-5 col-md-3 col-lg-2 ${blueBorderOnHover ? styles.border_blue_hover : ""}`} style={listStyle}>
                  {cloneElement(props.children, { ...categoryUrl, key: index })}
                </li>
              </HideIf>
            ))}
        </ul>
      </div>

      <ViewAllButton
        showButton={searchResult.length > maxRows * columnItemCount}
        isExpanded={showAll}
        onClick={(e: any) => {
          e.preventDefault();
          setShowAll(!showAll);
        }}
      />
    </div>
  );
}

export default CategorySection;
